import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../app/AllowedMicroservices";
import { RootState } from "../../app/store";
import apiActionCreator, { HttpMethods } from "../../services/apiActionCreator";
import { FetchStatus } from "../common/enums";

// Slice puntual para el modal de ranking de la infografía (ver
// components/Profile/Infographic/Ranking.tsx): solo necesita nombre/avatar
// por usuario, así que pega a POST /user/students/fields en vez de
// fetchStudents() de usersSlice.ts, que trae el documento completo de cada
// estudiante y además resetea el dict global state.users.dict.
export interface IRankingUser {
  name: string;
  picture?: string;
}
interface IRankingUserDict {
  [username: string]: IRankingUser;
}
interface RankingUsersState {
  fetching: FetchStatus;
  dict: IRankingUserDict;
}

const initialState: RankingUsersState = {
  fetching: FetchStatus.Idle,
  dict: {},
};

export const rankingUsersSlice = createSlice({
  name: "rankingUsers",
  initialState,
  reducers: {
    fetching: (state) => {
      state.fetching = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<Array<IRankingUser & { username: string }>>) => {
      state.dict = {};
      action.payload.forEach(({ username, ...user }) => {
        state.dict[username] = user;
      });
      state.fetching = FetchStatus.Fetched;
    },
    error: (state) => {
      state.fetching = FetchStatus.Error;
    },
  },
});

export const { error, fetched, fetching } = rankingUsersSlice.actions;

export const fetchRankingUsers = () => (dispatch: Dispatch<object>) => {
  return dispatch(
    apiActionCreator({
      endpoint: "/user/students/fields",
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.POST,
      microservice: Microservices.USER_SERVICE,
      authenticated: true,
      data: { fields: ["name", "picture"] },
    })
  );
};

export const selectRankingUsers = (state: RootState) => state.rankingUsers.dict;

export default rankingUsersSlice.reducer;
